import { View, Text, StyleSheet } from "react-native";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import * as Fonts from "../../../styles/typography";
import * as Colors from "../../../styles/colors";
import { formatHour } from "../../../helpers/util"
export default function UnityInfo({ contractData }) {
  return (
    <View>
      <View style={styles.viewUnityInfoData}>
        <View style={styles.doubleText}>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="car" size={32} />
              <Text style={styles.label}>{"Qtd. de vagas"}</Text>
            </View>
            <Text style={styles.info}>{contractData.amountSpace}</Text>
          </View>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="calendar-month-outline" size={32} />
              <Text style={styles.label}>{"Tabela"}</Text>
            </View>
            <Text style={styles.info}>{contractData.tablePrice.value.name}</Text>
          </View>
        </View>
        <View style={styles.doubleText}>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="bell-outline" size={32} />
              <Text style={[styles.label, { fontSize: Fonts.FONT_SIZE_16 }]}>{"Vencimento"}</Text>
            </View>
            <Text style={styles.info}>{"Todo dia " + contractData.dayPrice.payday}</Text>
          </View>
          <View style={styles.infoTicket}>
            <View style={styles.horizontalInfo}>
              <Icon name="timer" size={32} />
              <Text style={styles.label}>{"Horario"}</Text>
            </View>
            <Text style={styles.info}>{formatHour(contractData.tablePrice.value.startTime) 
            + " as " + 
            formatHour(contractData.tablePrice.value.endTime)}</Text>
          </View>
        </View>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  viewUnityInfoData: {
    // paddingHorizontal: 8,
  },
  viewUnityInfoTitle: {
    flexDirection: "row",
    alignItems: "center",
  },
  doubleText: {
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    // padding: 8,
    marginHorizontal: 4,
    marginVertical: 8,
  },
  label: {
    fontSize: Fonts.FONT_SIZE_18,
    color: Colors.BLACK,
    fontWeight: "bold",
    marginHorizontal: 4,
  },
  info: {
    fontSize: Fonts.FONT_SIZE_16,
  },
  infoTicket: {
    borderWidth: 1,
    borderRadius: 8,
    padding: 4,
    marginHorizontal: 4,
    width: "40%",
    alignContent: "center",
  },
  horizontalInfo: {
    flexDirection: "row",
    alignItems: "center",
  },
});
